import OfficeSuppliesPageState from "@GeriMed/Store/Pages/OfficeSupplies/OfficeSuppliesState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { reducers } from "@insite/client-framework/Store/Reducers";

const initialState: OfficeSuppliesPageState = {
    getOfficeSuppliesParameter: {
        customerNumber: "",
    }
};
const reducer = {};

const officeSuppliesPageReducer = createTypedReducerWithImmer(initialState,reducer);

(reducers as any).officeSuppliesPageState = officeSuppliesPageReducer;
